import * as React from 'react';
import { IconHouse16 } from '@cian/ui-kit/icons';

import * as styles from './BuildersList.css';
import { IPromoPopupBuilder } from '../../../../types/promosPage';
import { ListItem } from '../ListItem';

interface IBuildersListProps {
  builders: IPromoPopupBuilder[];
}

export function BuildersList({ builders }: IBuildersListProps) {
  return (
    <>
      <h3 className={styles['title']}>Застройщики</h3>
      <ul className={styles['container']}>
        {builders.map((builder, idx) => (
          <li key={idx} className={styles['item']}>
            <ListItem name={builder.name} logoUrl={builder.logo} defaultIcon={<IconHouse16 />} />
          </li>
        ))}
      </ul>
    </>
  );
}
